export default __webpack_public_path__ + "static/media/add_circle_outline-24px.19a69c63.svg";